import { Box, Grid, Typography, useMediaQuery } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import React, { useEffect, useState } from "react";
import store from "store";
import { useSelector } from "react-redux";
import theme from "../../assets/theme";
import MarkedAndTotal from "./MarkedAndTotal";
import MyStatistics from "./MyStatistics";
import TimeSpentTagging from "./TimeSpentTagging";
import ContentWrap from "../HomePage/Components/ContentWrap";
const useStyles = makeStyles(() => ({
  container: {
    // padding: "0 20% 0 20%",
    width: "100%",
  },
  "@media(max-width: 1024px)": {
    container: {
      // padding: "0 2% 0 2%",
    },
  },
  menuName: {
    verticalAlign: "top",
  },
  ansHead: {
    background: theme.palette.common.white,
  },
  subjectHeader: {
    display: "flex",
    alignItems: "center",
    borderRadius: "10px 10px 0px 0px",
    paddingLeft: "16px",
  },
  sectionDivider: {
    margin: "20px 0",
    height: "1px",
    background: "linear-gradient(90deg, transparent, #e0e0e0, transparent)",
  },
  contentSection: {
    marginBottom: "16px",
  },
  sectionTitle: {
    textAlign: "center",
    margin: "24px 0 16px",
    position: "relative",
    fontWeight: 800,
    fontSize: "16px",
    color: "#333",

    "&::after": {
      content: '""',
      position: "absolute",
      left: "50%",
      bottom: 0,
      transform: "translateX(-50%)",
      width: "100%",
      height: "2px",
      backgroundColor: "#ccc",
      marginTop: "8px",
      bgcolor: "#e0e0e0",
    },
  },
}));
function MyAnswers({ accessFeatures = {} }) {
  const [value, setValue] = useState(0);
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [finalResult, setFinalResult] = useState([]);
  const [dataMobileDevice, setDataMobileDevice] = useState([]);
  const [timeTag, setTimeTag] = useState({});
  const [allSubjectsData, setAllSubjectsData] = useState([]);
  const result = useSelector((state) => state.allResult);
  const rankAnalysis = useSelector((state) => state.rankAnalysis);
  const { data = {} } = rankAnalysis;
  const exam = store.get("examObject") || {};
  // const offline = exam.isOffline
  const offline =
    accessFeatures && accessFeatures.isAdmin
      ? accessFeatures.isOffline
      : exam.isOffline;
  const handleChange = (event, newValue) => {
    setValue(newValue);
    setTimeTag({});
  };
  const [state, setState] = useState({
    key: 0,
  });

  const handleMobileChange = (event) => {
    setState({
      ...state,
      [event.target.name]: Number(event.target.value),
    });
    setTimeTag({});
  };
  //extracting data subject wise
  const subjectWiseData = (totalData, subjectKey) => {
    return totalData.data.filter(
      (item) =>
        item.subjectName.toUpperCase() === totalData.subjects[subjectKey]
    );
  };
  useEffect(() => {
    const finalData = subjectWiseData(result, value);
    const dataForMobileDevice = subjectWiseData(result, state.key);
    setFinalResult(finalData);
    setDataMobileDevice(dataForMobileDevice);

    // Prepare data for all subjects
    const allSubjects = result.subjects.map((subject, index) => ({
      subject,
      index,
      data: subjectWiseData(result, index),
    }));
    setAllSubjectsData(allSubjects);
  }, [value, state.key, result]);
  const classes = useStyles();

  // Dynamic subject icons and colors
  const getSubjectIcon = (subject) => {
    const subjectLower = subject.toLowerCase();
    if (subjectLower.includes("physics") || subjectLower.includes("phy"))
      return "⚡";
    if (subjectLower.includes("chemistry") || subjectLower.includes("chem"))
      return "🧪";
    if (
      subjectLower.includes("mathematics") ||
      subjectLower.includes("math") ||
      subjectLower.includes("maths")
    )
      return "📐";
    if (subjectLower.includes("botany") || subjectLower.includes("bot"))
      return "🧬";
    if (subjectLower.includes("zoology") || subjectLower.includes("zoo"))
      return "🐾";
    if (subjectLower.includes("english") || subjectLower.includes("eng"))
      return "📚";
    if (subjectLower.includes("overall") || subjectLower.includes("total"))
      return "🏆";
    return "📖"; // Default icon for other subjects
  };

  // Helper function to get subject display name
  const getSubjectDisplayName = (subject) => {
    switch (subject) {
      case "MATHEMATICS":
        return "Mathematics";
      case "PHYSICS":
        return "Physics";
      case "CHEMISTRY":
        return "Chemistry";
      case "BOTANY":
        return "Botany";
      case "ZOOLOGY":
        return "Zoology";
      case "BIOLOGY":
        return "Biology";
      default:
        return subject;
    }
  };

  // Helper function to get subject color
  const getSubjectColor = (subject) => {
    const subjectLower = subject.toLowerCase();
    if (subjectLower.includes("physics") || subjectLower.includes("phy"))
      return "#2196F3";
    if (subjectLower.includes("chemistry") || subjectLower.includes("chem"))
      return "#FF9800";
    if (
      subjectLower.includes("mathematics") ||
      subjectLower.includes("math") ||
      subjectLower.includes("maths")
    )
      return "#4CAF50";
    if (subjectLower.includes("biology") || subjectLower.includes("bio"))
      return "#8BC34A";
    if (subjectLower.includes("english") || subjectLower.includes("eng"))
      return "#E91E63";
    if (subjectLower.includes("computer") || subjectLower.includes("cs"))
      return "#607D8B";
    if (subjectLower.includes("overall") || subjectLower.includes("total"))
      return "#9C27B0";
    // Generate a consistent color for unknown subjects based on their name
    const colors = [
      "#F44336",
      "#9C27B0",
      "#673AB7",
      "#3F51B5",
      "#2196F3",
      "#03A9F4",
      "#00BCD4",
      "#009688",
      "#4CAF50",
      "#8BC34A",
      "#CDDC39",
      "#FFEB3B",
      "#FFC107",
      "#FF9800",
      "#FF5722",
    ];
    const index = subject.length % colors.length;
    return colors[index];
  };

  //handle time tagging
  const handleTagClick = (arg) => {
    setTimeTag(arg);
  };

  return (
    <React.Fragment>
      <Grid
        container
        direction="row"
        justify="space-between"
        className={classes.container}
        style={{ marginTop: isMobile ? "0px" : "16px" }}
        spacing={1}
      >
        {/* Display all subjects and their data */}
        {allSubjectsData.map((subjectData, index) => (
          <Grid item xs={12} key={index}>
            <ContentWrap>
              {index === 0 && (
                <Box
                  className={classes.sectionTitle}
                  style={{
                    fontFamily: "'Quicksand', sans-serif",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexDirection: "row",
                  }}
                >
                  <Typography variant={isMobile ? "subtitle1" : "h6"} style={{ fontWeight: "bold" }}>
                    📖 My&nbsp;&nbsp;
                  </Typography>
                  <Typography
                    variant={isMobile ? "subtitle1" : "h6"}
                    style={{ fontWeight: "bold", color: "#FF9800" }}
                  >
                    Answers
                  </Typography>
                </Box>
              )}
              {/* Subject Header with Icon */}
              <div className={classes.subjectHeader}>
                <Box mr={1}>{getSubjectIcon(subjectData.subject)}</Box>
                <Typography
                  variant="h4"
                  className={classes.subjectTitle}
                  style={{ color: getSubjectColor(subjectData.subject) }}
                >
                  {getSubjectDisplayName(subjectData.subject)}
                </Typography>
              </div>

              <Grid container spacing={3}>
                {/* Marked Answers */}
                <Grid item xs={12} className={classes.contentSection}>
                  <MarkedAndTotal
                    subject={subjectData.subject}
                    markedAns={subjectData.data}
                    timeTag={timeTag}
                  />
                  {!offline && <div className={classes.sectionDivider} />}
                </Grid>

                {/* Time Spent Tagging for MAIN/JEE ADVANCED */}
                {data.testType &&
                  (data.testType.includes("MAIN") ||
                    data.testType === "JEE ADVANCED") &&
                  !offline && (
                    <Grid item xs={12} className={classes.contentSection}>
                      <TimeSpentTagging
                        questions={subjectData.data}
                        sub={subjectData.subject}
                        testData={data}
                        handleTagClick={(param) => {
                          handleTagClick(param);
                        }}
                      />
                      <div className={classes.sectionDivider} />
                    </Grid>
                  )}

                {/* Statistics */}
                {!offline && (
                  <Grid item xs={12} className={classes.contentSection}>
                    <MyStatistics
                      timeSpentData={subjectData.data}
                      subject={subjectData.subject}
                      /* Based on index My Exam Behaviour will be shown only for the first subject */
                      index={index}
                    />
                  </Grid>
                )}
              </Grid>
            </ContentWrap>
            <Grid />
          </Grid>
        ))}
      </Grid>
    </React.Fragment>
  );
}

export default MyAnswers;
